// extracted by mini-css-extract-plugin
export default {"container":"style_container__FbH9j","innerBox":"style_innerBox__iPNjt","head":"style_head__FmMTV","body":"style_body__WO6it","ulInfo":"style_ulInfo__23g-R"};